import { getUrlFromLocation } from '@zcode/nr/es/shared/utils/urls/getUrlFromLocation'
import type {
  AIAssistantLocationResponse,
  FiltersState,
  Location,
  SaveSearchLocationBox,
} from '@zcode/state-type'
import { getRelativeUrlFromFiltersAndLocation } from './getRelativeUrlFromFiltersAndLocation'

const APTS_BASE_URL = 'apartments-for-rent'

export const createUrlFromLocationAndFilter = ({
  filters,
  location,
}: {
  filters: FiltersState
  location: Partial<Location> | (Omit<AIAssistantLocationResponse, 'box'> & { box: null })
}) => {
  const locationUrl = getUrlFromLocation(location)

  const relUrl = getRelativeUrlFromFiltersAndLocation({
    filters,
    currentUrl: locationUrl.path,
    locationUrlQueries: locationUrl.searchQueries,
  }).replace(/\/{2,}/g, '/')

  return relUrl.includes(APTS_BASE_URL) ? relUrl : `/${APTS_BASE_URL}/${relUrl}`
}
